import { LOAN_REQUEST_OFFER_SOURCES, LOAN_REQUEST_OFFER_STATUS } from 'cpool-constants';
import type { SchemaLoanRequestResolver_GetAcceptedOffers } from 'cpool-tables/backend-resolvers';

export const getIsActiveConsorsOffer = (offer: SchemaLoanRequestResolver_GetAcceptedOffers[number]) =>
    offer.source === LOAN_REQUEST_OFFER_SOURCES.CONSORS &&
    offer.status !== LOAN_REQUEST_OFFER_STATUS.OFFER_EXPIRED &&
    offer.status !== LOAN_REQUEST_OFFER_STATUS.CANCELLED;
